import { render, staticRenderFns } from "./nominas.vue?vue&type=template&id=51382aeb"
import script from "./nominas.vue?vue&type=script&lang=js"
export * from "./nominas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports